import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60739114")

_pushScopeId("data-v-60739114")
const _hoisted_1 = {
  key: 1,
  class: "tip-arrow"
}
const _hoisted_2 = {
  key: 2,
  class: "tiptext"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")

  return (_openBlock(), _createBlock("div", {
    class: "tooltip",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_ctx.showTip)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "tip-bg",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.HandleClose && _ctx.HandleClose(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Pic, {
      class: "ml-4",
      src: "user/help",
      width: "16",
      height: "16",
      onClick: _ctx.HandleTaggle
    }, null, 8, ["onClick"]),
    (_ctx.showTip)
      ? (_openBlock(), _createBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showTip)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("p", null, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})